module.exports = "https://cdn.hellotech.com/client-assets/fleet-quality_e2d5c9581919dd07ad73871f9f9ebcfe.jpg";